import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import Logo from "./Logo";
import { brand } from "../mock";

const links = [
  { label: "Home", href: "/#home", type: "route" },
  { label: "Courses", href: "/#courses", type: "route" },
  { label: "Study in Korea", href: "/study-in-korea", type: "route", highlight: true },
  { label: "Location", href: "/#location", type: "route" },
  { label: "Contact", href: "/#contact", type: "route" },
];

export default function Navbar({ onEnroll }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur border-b border-black/5 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-3">
          <Logo size={40} />
          <div className="leading-tight">
            <div className="font-extrabold tracking-wide brand-navy text-lg">
              CYA <span className="gold-text">Youth Academy</span>
            </div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#0A1740]/60">
              {brand.location}
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.href}
              to={l.href}
              className={`text-sm font-semibold transition-colors ${
                l.highlight
                  ? "text-[#B45309] hover:text-[#F59E0B] px-3 py-1 rounded-full bg-[#FEF3C7] border border-[#F59E0B]/30"
                  : "text-[#0A1740]/80 hover:text-[#F59E0B]"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={brand.phoneDial}
            className="btn-ghost px-4 py-2 rounded-full text-sm inline-flex items-center gap-2"
          >
            <Phone size={16} /> {brand.phone}
          </a>
          <button
            onClick={onEnroll}
            className="btn-primary px-5 py-2.5 rounded-full text-sm"
          >
            Join Today
          </button>
        </div>

        <button
          className="lg:hidden brand-navy p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white/95 border-t border-black/5 px-5 py-4 space-y-3">
          {links.map((l) => (
            <Link
              key={l.href}
              to={l.href}
              onClick={() => setOpen(false)}
              className={`block font-semibold py-2 border-b border-black/5 ${
                l.highlight ? "text-[#B45309]" : "text-[#0A1740]/80"
              }`}
            >
              {l.label}{l.highlight && <span className="ml-2 text-[10px] uppercase tracking-widest bg-[#FEF3C7] text-[#B45309] px-2 py-0.5 rounded-full">New</span>}
            </Link>
          ))}
          <div className="flex gap-2 pt-2">
            <a
              href={brand.phoneDial}
              className="btn-ghost flex-1 py-2 rounded-full text-sm inline-flex items-center justify-center gap-2"
            >
              <Phone size={16} /> Call
            </a>
            <button
              onClick={() => {
                setOpen(false);
                onEnroll?.();
              }}
              className="btn-primary flex-1 py-2 rounded-full text-sm"
            >
              Join Today
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
